module.exports = __webpack_public_path__ + "img/247.Personal_attention.6649feec.svg";